export default __webpack_public_path__ + "static/media/avatar8.c4cc5fb5.svg";